import type React from "react";

import { twResolve } from "@/helpers/tw-resolve";

import type { IconComponent } from "../Icon/Icon";
import type { RadioProps } from "./Radio";
import { Radio } from "./Radio";

export type RadioCardProps = RadioProps & {
  label: string;
  description?: string;
  icon?: IconComponent;
  children?: React.ReactNode;
};

export function RadioCard({ label, description, icon, children, ...otherProps }: RadioCardProps): React.ReactNode {
  return (
    <label
      className={twResolve(
        "flex w-full cursor-pointer flex-col gap-2 rounded-lg border border-grey-300 bg-white p-4 transition-colors  duration-200",
        (otherProps.defaultChecked || otherProps.checked) && "border-aop-basic-blue-500 bg-aop-basic-blue-50",
      )}
    >
      <div className="flex items-start gap-2">
        <div className="flex h-6 items-center">
          <Radio {...otherProps} />
        </div>
        {icon && <span className="[&_svg]:size-6 [&_svg]:text-black">{icon}</span>}
        <span className="text-body-bold">{label}</span>
      </div>
      {description && <p className="text-caption text-grey-700">{description}</p>}
      {children}
    </label>
  );
}
